module.exports = __webpack_public_path__ + "img/1 (42).89da5549.png";